import React from 'react';
import useCan from '@shared/permissions/useCan';
import InventoryHoldShow from '@components/shared/inventory/InventoryHoldShow';
import { inventoryHoldService } from '@services/operator/inventoryHoldService';

export default function InventoryHoldShowPage() {
  const can = useCan();
  const canRelease = can('inventories:write');

  return (
    <InventoryHoldShow
      service={inventoryHoldService}
      role="operator"
      canRelease={canRelease}
    />
  );
}
